import { Input } from 'rsuite';
import React from 'react';
import { FormField } from '../../common/FormModal';
import LanguageTabs, {
  getLanguagePanelId,
  getLanguageTabId,
  LanguageKey,
} from '../../common/LanguageTabs';

type Props = {
  modalPartnerName: string;
  modalPartnerNameEn: string;
  modalPartnerNameDe: string;
  modalPartnerDescription: string;
  modalPartnerDescriptionEn: string;
  modalPartnerDescriptionDe: string;
  modalPartnerDescriptionLong: string;
  modalPartnerDescriptionLongEn: string;
  modalPartnerDescriptionLongDe: string;
  modalPartnerAnnotation: string;
  modalPartnerAnnotationEn: string;
  modalPartnerAnnotationDe: string;
  modalPartnerLink: string;
  setModalPartnerName: (value: string) => void;
  setModalPartnerNameEn: (value: string) => void;
  setModalPartnerNameDe: (value: string) => void;
  setModalPartnerDescription: (value: string) => void;
  setModalPartnerDescriptionEn: (value: string) => void;
  setModalPartnerDescriptionDe: (value: string) => void;
  setModalPartnerDescriptionLong: (value: string) => void;
  setModalPartnerDescriptionLongEn: (value: string) => void;
  setModalPartnerDescriptionLongDe: (value: string) => void;
  setModalPartnerAnnotation: (value: string) => void;
  setModalPartnerAnnotationEn: (value: string) => void;
  setModalPartnerAnnotationDe: (value: string) => void;
  setModalPartnerLink: (value: string) => void;
};

export default function PartnerModalContent({
  modalPartnerName,
  modalPartnerNameEn,
  modalPartnerNameDe,
  modalPartnerDescription,
  modalPartnerDescriptionEn,
  modalPartnerDescriptionDe,
  modalPartnerDescriptionLong,
  modalPartnerDescriptionLongEn,
  modalPartnerDescriptionLongDe,
  modalPartnerAnnotation,
  modalPartnerAnnotationEn,
  modalPartnerAnnotationDe,
  modalPartnerLink,
  setModalPartnerName,
  setModalPartnerNameEn,
  setModalPartnerNameDe,
  setModalPartnerDescription,
  setModalPartnerDescriptionEn,
  setModalPartnerDescriptionDe,
  setModalPartnerDescriptionLong,
  setModalPartnerDescriptionLongEn,
  setModalPartnerDescriptionLongDe,
  setModalPartnerAnnotation,
  setModalPartnerAnnotationEn,
  setModalPartnerAnnotationDe,
  setModalPartnerLink,
}: Props) {
  const [activeLanguage, setActiveLanguage] = React.useState<LanguageKey>('ua');
  const languageTabPrefix = 'partner-language';

  const languageConfig: Record<
    LanguageKey,
    {
      name: string;
      setName: (value: string) => void;
      description: string;
      setDescription: (value: string) => void;
      descriptionLong: string;
      setDescriptionLong: (value: string) => void;
      annotation: string;
      setAnnotation: (value: string) => void;
    }
  > = {
    ua: {
      name: modalPartnerName,
      setName: setModalPartnerName,
      description: modalPartnerDescription,
      setDescription: setModalPartnerDescription,
      descriptionLong: modalPartnerDescriptionLong,
      setDescriptionLong: setModalPartnerDescriptionLong,
      annotation: modalPartnerAnnotation,
      setAnnotation: setModalPartnerAnnotation,
    },
    en: {
      name: modalPartnerNameEn,
      setName: setModalPartnerNameEn,
      description: modalPartnerDescriptionEn,
      setDescription: setModalPartnerDescriptionEn,
      descriptionLong: modalPartnerDescriptionLongEn,
      setDescriptionLong: setModalPartnerDescriptionLongEn,
      annotation: modalPartnerAnnotationEn,
      setAnnotation: setModalPartnerAnnotationEn,
    },
    de: {
      name: modalPartnerNameDe,
      setName: setModalPartnerNameDe,
      description: modalPartnerDescriptionDe,
      setDescription: setModalPartnerDescriptionDe,
      descriptionLong: modalPartnerDescriptionLongDe,
      setDescriptionLong: setModalPartnerDescriptionLongDe,
      annotation: modalPartnerAnnotationDe,
      setAnnotation: setModalPartnerAnnotationDe,
    },
  };

  const activeLanguageConfig = languageConfig[activeLanguage];

  return (
    <>
      <FormField label="Посилання">
        <Input
          placeholder="Посилання"
          value={modalPartnerLink || ''}
          onChange={setModalPartnerLink}
        />
      </FormField>
      <LanguageTabs
        activeLanguage={activeLanguage}
        onChange={setActiveLanguage}
        idPrefix={languageTabPrefix}
      />
      <div
        className="language-panel"
        role="tabpanel"
        id={getLanguagePanelId(languageTabPrefix, activeLanguage)}
        aria-labelledby={getLanguageTabId(languageTabPrefix, activeLanguage)}
      >
        <div className="language-fields">
          <FormField label="Назва">
            <Input
              placeholder="Назва"
              value={activeLanguageConfig.name || ''}
              onChange={activeLanguageConfig.setName}
            />
          </FormField>
          <FormField label="Короткий опис">
            <Input
              as="textarea"
              rows={3}
              placeholder="Короткий опис"
              value={activeLanguageConfig.description || ''}
              onChange={activeLanguageConfig.setDescription}
            />
          </FormField>
          <FormField label="Довгий опис">
            <Input
              as="textarea"
              rows={5}
              placeholder="Довгий опис"
              value={activeLanguageConfig.descriptionLong || ''}
              onChange={activeLanguageConfig.setDescriptionLong}
            />
          </FormField>
          <FormField label="Анотація">
            <Input
              as="textarea"
              rows={3}
              placeholder="Анотація"
              value={activeLanguageConfig.annotation || ''}
              onChange={activeLanguageConfig.setAnnotation}
            />
          </FormField>
        </div>
      </div>
    </>
  );
}
